import { errors } from '../content'

export default {
  validateOrderError: {
    message: errors.invalidEmailForEdgeProduct
  }
}
